import { IDataHandler } from '../IDataHandler';
import { TrackingEventName } from '../TrackingEvent';
import { EntryPointDataSet } from '../DataSet/EntryPoint';

/**
 * ==============================
 * ========= NOTICE =============
 * ==============================
 *
 * gameStarted should be identical to gameLoaded!
 * If you add events to either, you must update the other!
 */
const SharedEntryPointData: (keyof EntryPointDataSet)[] = [
    'entryPoint',
    'epSenderId',
    'epSenderLevel',
    'epSenderIsPayer',
    'epTimestamp',
    'epContext',
    'epPromoSource',
    'mOrigin',
    'mAdType',
    'mAdName',
    'mChannel',
    'mAdId',
    'mAdsetID',
    'mCampaignID',
    'customEntryPoint',
    'aTrackerToken',
    'aTrackerName',
    'aAdGroup',
    'aCreative',
    'aClickLabel',
    'aAdID',
    'aNetwork',
    'aCampaignID'
];

export const TrackingEventDataMap: {
    [key in TrackingEventName]: (keyof EntryPointDataSet)[];
} = {
    [TrackingEventName.gameLoaded]: SharedEntryPointData,
    [TrackingEventName.gameStarted]: SharedEntryPointData,
    [TrackingEventName.newPlayer]: SharedEntryPointData
};

export class EntryPointDataHandler implements IDataHandler<EntryPointDataSet> {
    public data: EntryPointDataSet = new EntryPointDataSet();

    public getEventData(eventName: TrackingEventName): EntryPointDataSet {
        const data = TrackingEventDataMap[eventName].reduce((acc, key) => {
            acc[key] = this.data[key] as never;
            return acc;
        }, {} as EntryPointDataSet);

        return data;
    }

    public clearData(): void {
        this.data = new EntryPointDataSet();
    }
}
